import { isDefined } from "@recursyve/nice-ts-utils";
import { Tickets } from "../api/acl/ticket/models/tickets.model";

export class BatchNumberUtils {
    // Sorts batch numbers numerically ascending.
    public static compareTicketsByBatchNumber(a: Tickets, b: Tickets): number {
        const batchNumberA = BatchNumberUtils.parseBatchNumber(a.batchNumber);
        const batchNumberB = BatchNumberUtils.parseBatchNumber(b.batchNumber);

        if (batchNumberA == null && batchNumberB == null) {
            return BatchNumberUtils.compareById(a, b);
        }

        if (batchNumberA == null) {
            return 1;
        }

        if (batchNumberB == null) {
            return -1;
        }

        if (batchNumberA !== batchNumberB) {
            return batchNumberA - batchNumberB;
        }

        return BatchNumberUtils.compareById(a, b);
    }

    private static parseBatchNumber(batchNumber: string | null | undefined): number | null {
        if (!isDefined(batchNumber) || batchNumber.trim().length === 0) {
            return null;
        }

        const parsed = Number(batchNumber.trim());

        return Number.isFinite(parsed) ? parsed : null;
    }

    private static compareById(a: Tickets, b: Tickets): number {
        return (a.id ?? 0) - (b.id ?? 0);
    }
}
